import React from "react";
import { Box, Grid, makeStyles, MenuItem, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useState } from 'react';
import FormSectionHeader from "../FormSectionHeader";

const useStyles = makeStyles((theme) => ({
  section: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }
}))


function ReviewForm(props) {
  const classes = useStyles();
  const { t } = useTranslation('incidentManagement');

  const { data, statusList, onFormChange, ...rest } = props;
  const { reviewTypeList } = statusList;

  const StatusList = [
    {
      id: 1,
      name: t('no_deduction'),
      value: 0
    },
    {
      id: 2,
      name: t('deducted'),
      value: 1
    }
  ];

  return (
    <Box {...rest}>
      <FormSectionHeader
        title={t('review')}
      />
      <form>
        <Grid container spacing={4} className={classes.section}>
          <Grid item xs={12}>
            <TextField
              id='select-review-confirm'
              name="review_type"
              label={t('reviewed_confirmed')}
              variant='outlined'
              value={data.review_type}
              onChange={onFormChange}
              select
              fullWidth
              required
            >
              {reviewTypeList.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6}>
          <TextField
              id="incidentmanagement_reviewform_consigneerefund_textfield"
              variant="outlined"
              name="consignee_refund"
              label={t('consignee_refund')}
              value={data.consigneeRefund}
              defaultValue={data.consigneeRefund}
              onChange={onFormChange}
              fullWidth
              className={classes.textField}
              select
            >
              {StatusList.map((item) => (
                <MenuItem key={item.id} value={item.value}>
                  {t(item.name)}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="incidentmanagement_reviewform_clientrefund_textfield"
              variant="outlined"
              name="client_refund"
              label={t('client_refund')}
              value={data.clientRefund}
              defaultValue={data.clientRefund}
              onChange={onFormChange}
              fullWidth
              className={classes.textField}
              select
            >
              {StatusList.map((item) => (
                <MenuItem key={item.id} value={item.value}>
                  {t(item.name)}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label={t('close_time')}
              variant='outlined'
              fullWidth
              disabled
              defaultValue={moment.unix(data.close_time).format("YYYY-MM-DD")}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="input-notes"
              label={t('notes')}
              name="notes"
              variant='outlined'
              defaultValue={data.notes}
              multiline
              onChange={onFormChange}
              rows={4}
              fullWidth
            />
          </Grid>
        </Grid>
      </form>
    </Box>
  )
}

export default ReviewForm;